import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  EventEmitter,
  inject,
  Output,
  signal,
  viewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectSelectedChannel } from '../../../../store/app.selectors';

import { IChannel } from '../../interfaces/IChannel';
import { TranslaterService } from '../../services/translater.service';
import { setChannelLang } from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LanguageSelectorComponent {
  @Output() selectLanguage = new EventEmitter<string>();

  private translaterService = inject(TranslaterService);
  private store = inject(Store<AppStateWithChat>);

  languageInput = viewChild<ElementRef<HTMLInputElement>>('languageInput');
  languageFilter = signal('');

  selectedChannel = toSignal(this.store.select(selectSelectedChannel), {
    initialValue: null as IChannel | null,
  });

  constructor() {
    effect(() => {
      this.languageFilter();
      queueMicrotask(() => this.languageInput()?.nativeElement?.focus());
    });
  }

  filteredLanguages = computed(() => {
    const filter = this.languageFilter().toLowerCase();
    if (!filter) {
      return this.translaterService.languageCodes;
    }
    return this.translaterService.languageCodes.filter(
      (lang) => lang.name.toLowerCase().includes(filter) || lang.key.toLowerCase().includes(filter)
    );
  });

  public resetFilter(): void {
    setTimeout(() => {
      this.languageFilter.set('');
    }, 1000);
  }

  trackByLang(index: number, lang: { key: string }): string {
    return lang.key;
  }

  onSelect(langKey: string) {
    this.store.dispatch(setChannelLang({ lang: langKey, channelUID: this.selectedChannel()!.uid }));
    this.selectLanguage.emit(langKey);
  }
}
